import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=64fabbc9&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fabbc9')) {
      api.createRecord('64fabbc9', component.options)
    } else {
      api.reload('64fabbc9', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=64fabbc9&", function () {
      api.rerender('64fabbc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HcnCGlfH4h0n/JS/videoIframe.vue"
export default component.exports